// {{WORKTREE_ROOT}}/picosponsorconsole/app/components/shell/MachineTranslationNote.tsx
// PLAN2 WP33 D33-9 — one line at the top of every console, Room and capture page while the UI language is a machine draft.
// On the console host it links to Your account → Language; on the Room and capture it is text only (a guest has no account page).
import { DesignLink } from "@picosponsor/design";
import type { HostKind } from "~/config/hosts";
import { useT } from "~/utils/locale";
import { TESTIDS } from "~/utils/testids";

export function MachineTranslationNote({ hostKind }: { hostKind: HostKind }) {
  const t = useT();
  return (
    <div role="note" data-testid={TESTIDS.shell.mtNote.root} className="bg-ochre-wash text-ink border-b border-line px-7 py-2 text-14 flex flex-wrap gap-x-3 gap-y-1">
      <span>{t("shell", "mt-note-body")}</span>
      {hostKind === "app" ? (
        <DesignLink href="/account#language" className="font-bold underline text-ink" data-testid={TESTIDS.shell.mtNote.change}>{t("shell", "mt-note-action")}</DesignLink>
      ) : null}
    </div>
  );
}
